import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FlowRunAction } from '../obj/FlowRunAction';

@Component({
    selector: 'app-gantt',
    templateUrl: './gantt.component.html',
    styleUrls: ['./gantt.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class GanttComponent implements OnInit, AfterViewInit {

  constructor() { }

  @Input()
  public actions: FlowRunAction[];
  public diagramText: string;

  @ViewChild('outputGantt', { static: false}) 
  outputGantt: ElementRef;

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.refresh();
  }

  refresh() {

    let diagram = 
`gantt
    title A Gantt Diagram
    dateFormat YYYY-MM-DDTHH:mm:ss.SSSZ
    axisFormat %Y-%m-%d %H:%M:%S
`;

// section Section
// A task           :a1, 2014-01-01, 30d
// Another task     :after a1  , 20d
// section Another
// Task in sec      :2014-01-12  , 12d
// another task      : 24d

    this.actions.forEach((action)=>{


      diagram += `    ${action.name}:${action.duration<1000?'active, ':''}${action.name}, ${action.startTime.toISOString()}, ${action.endTime?.toISOString()}\n`;

    })


    this.diagramText = diagram;

    var output = this.outputGantt.nativeElement as HTMLDivElement; // document.getElementById('output');

    (<any>window).mermaid.initialize({
      startOnLoad: true,
      flowchart: {
        htmlLabels: true
      },
      securityLevel:'loose'
    });
    (<any>window).mermaid.render('theGantt', diagram, (svg)=>{
      output.innerHTML = svg;
    })

  }
}
